import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-types-papi';
import MiniProfileIdentity from '../_partials/MiniProfileIdentity';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';

import s from './ActiveMembers.scss';

export interface Props {
  moduleId: number;
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  isWide: boolean;
  seeAllUrl: string;
  browseUrl: string;
  username: string;
  deviants: PapiUser[];
}

export const ActiveMembers: React.FC<Props> = ({ isWide, deviants }) => {
  return (
    <ElementQueries
      widthBreakpoints={[640, 800]}
      className={classnames(s['grid'], !isWide && s['grid-flex'])}
    >
      {deviants.map(deviant => (
        <MiniProfileIdentity
          key={deviant.username}
          className={s['member']}
          user={deviant}
          withTooltip
        />
      ))}
    </ElementQueries>
  );
};
ActiveMembers.displayName = 'ActiveMembers';

export default ActiveMembers;
